import React from 'react';
import './AdsPopover.css';

export default () => (
  <div className="AdsPopover">
    <div className="content">
      <div className="h2_lk">РЕКЛАМА - ПРОДВИГАЕТ</div>
      <div className="logo_lk">
        <a href="https://ads-market.ru/">ads-market.ru</a>
      </div>
      <div className="phone">
        <a href="tel:88126276776">+7 812 <b>627 67 76</b></a>
      </div>
      <div className="mail">
        <a href="mailto:info@ads-market.ru" className="mail">info@ads-market.ru</a>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/AdsPopover/AdsPopover.jsx